import { CourseOfferingLandingPageOverview } from './course-offering-landing-page-overview.model';

export class CourseOfferingLandingPageCommand {
    title: string;
    short_description: string;
    language: string;
    status: string;
    image: {
        id: number;
    };

    constructor(query: CourseOfferingLandingPageOverview) {
        this.title = query.title;
        this.short_description = query.shortDescription;
        this.language = query.language;
        this.status = query.status;

        this.image = query.image ? { id: Number(query.image.id) } : null;
    }
}
